// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var DateFns = require("../../../shared/utils/DateFns.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.bs.js");

function decode(json) {
  return {
          name: Json_decode.field("name", Json_decode.string, json),
          levelId: Json_decode.field("levelId", Json_decode.string, json),
          accessEndsAt: Belt_Option.map(Json_decode.optional((function (param) {
                      return Json_decode.field("accessEndsAt", Json_decode.string, param);
                    }), json), DateFns.parseISO)
        };
}

function levelId(t) {
  return t.levelId;
}

function accessEndsAt(t) {
  return t.accessEndsAt;
}

function accessEnded(t) {
  return Belt_Option.mapWithDefault(t.accessEndsAt, false, DateFns.isPast);
}

exports.decode = decode;
exports.levelId = levelId;
exports.accessEndsAt = accessEndsAt;
exports.accessEnded = accessEnded;
/* DateFns Not a pure module */
